import { ethers } from 'ethers';
import { ERC20, ERC20__factory } from '@orionprotocol/contracts/lib/ethers-v6';

import { useContract } from './useContract';

export function useERC20Contract(
  address: string | undefined,
  provider: ethers.Provider | undefined,
): ERC20 | undefined {
  const erc20Contract = useContract(address, provider, ERC20__factory);

  return erc20Contract;
}
